import type { Router } from 'vue-router';

/**
 * Date Parameter Redirect Guard
 *
 * Handles backward compatibility for old date URL format:
 * Old: ?date=2025-10-19
 * New: ?startDate=2025-10-19&endDate=2025-10-19
 *
 * This guard ensures old bookmarks and shared links continue to work
 * by automatically redirecting to the new URL format.
 */
export function dateRedirectGuard(router: Router) {
  router.beforeEach((to, _from, next) => {
    // Check if URL has old 'date' param but not new 'startDate'/'endDate' params
    if (to.query.date && !to.query.startDate && !to.query.endDate) {
      const { date, ...otherQuery } = to.query;

      // Redirect to new format with replace: true to avoid polluting history
      return next({
        path: to.path,
        query: {
          ...otherQuery,
          startDate: date,
          endDate: date,
        },
        hash: to.hash,
        replace: true, // Replace current history entry instead of adding new one
      });
    }

    // No redirect needed
    return next();
  });
}
